import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

import { withConfig } from 'src/withConfig';



export type RaceIndicatorVariant = 'primary' | 'secondary';



const setRaceIndicator = (theme: EmotionTheme, size: 'small' | 'medium'): SerializedStyles => {

    if (size === 'small') {

        return css`

            font-size: ${theme.star.fontSize.xxSmall};

            height: 16px;

            line-height: 1;

            padding: 4px 2px;

            width: 24px;

        `;

    }



    return css`

        font-size: ${theme.star.fontSize.small};

        height: 24px;

        line-height: 0.8;

        padding: 8px 2px 7px;

        width: 36px;

    `;

};



interface RaceIndicatorPropsType {

    size: 'small' | 'medium';

    variant: RaceIndicatorVariant;

}



export const RaceIndicatorWrapper = withConfig(theme => styled('div', { label: 'RaceIndicatorWrapper' })<RaceIndicatorPropsType>`

    ${({ size }): SerializedStyles => setRaceIndicator(theme, size)};

    border-radius: 2px;

    background-color: ${({ variant }): string => theme.star.raceIndicator[variant].bgColor};

    color: ${({ variant }): string => theme.star.raceIndicator[variant].txtColor};

    display: inline-flex;

    align-items: center;

    gap: 4px;

    font-weight: ${theme.star.fontWeight.bold};

    letter-spacing: -0.5px;

    padding-left: 4px;

    padding-right: 4px;

    white-space: nowrap;

    width: auto;

`);



export const RaceIndicatorIcon = styled('span', { label: 'RaceIndicatorIcon' })`

    align-items: center;

    display: inline-flex;

    flex: none;

`;



export const RaceIndicatorLabel = styled('span', { label: 'RaceIndicatorLabel' })`

    display: inline-block;

`;



export const RaceIndicatorsWrapper = withConfig(theme => styled('div', { label: 'RaceIndicatorsWrapper' })`

    align-items: center;

    display: flex;

    flex-wrap: wrap;

    gap: 4px;

    margin-top: 4px;

    &:empty {

        display: none;

    }

    @media ${theme.star.mediaQuery.desktop} {

        flex-wrap: nowrap;

        margin-top: 0;

        position: absolute;

        right: 8px;

        top: 6px;

    }

`);

